import { logoutCometChat } from '~/middlewares/comet-chat';
import { observeStore } from '~/redux/obesrvers/observeStore';
import radarObserver from '~/redux/obesrvers/radarObserver';
import { chatRadarEnabledSelector } from '~/redux/selectors';

const getChatRadarChangeListener = (store) => {
  let unsubscribeFromRadarObserver;

  return (isChatRadarEnabled) => {
    if (isChatRadarEnabled) {
      unsubscribeFromRadarObserver = radarObserver(store);
    } else if (unsubscribeFromRadarObserver) {
      unsubscribeFromRadarObserver();
      logoutCometChat();
    }
  };
};

export default (store) =>
  observeStore(
    store,
    chatRadarEnabledSelector,
    getChatRadarChangeListener(store),
  );
